<template>
  <v-row>
    <globalNav
      :dynamicItems="dynamicItems"
      :canClickXiftLogo="canClickXiftLogo"
    />
  </v-row>
</template>

<script>
import globalNav from './GlobalNav';
export default {
  props: {
    dynamicItems: { type: Array },
    canClickXiftLogo: { type: Boolean, default: true }
  },
  components: {
    globalNav
  }
};
</script>

<style></style>
